import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import getCbInstance from "../../helpers/chargebee-instance.helper";
import { IEstimateInvoiceModel, mapChargebeeEstimateInvoice, PaymentStatus } from "../../models/payment.model";
import { PlanType, TierOccurrence } from "../../models/plans.model";
import ChargebeeService from "../../services/chargebee.service";
import { UserService } from "../../services/UserService";
import { useLocation } from "react-router-dom";
import PaymentHostpageDetails from "./NewPaymentHostpageDetails";
import { OrganizationService } from "../../services/OrganizationService";
import { mapToOrganizationDetails, OrganizationDetails } from "../../models/organization.model";
import chargebeeService from "../../services/chargebee.service";
import { RechargeStatus } from "../../models/transaction-history.model";

export interface IPaymentProps {
    HandleNext: (data: any) => void;
    IsMobileDevice?: boolean;
    Stepdata?: any
}
const NewPayment = (props: IPaymentProps) => {
    const cbInstance = getCbInstance();
    const { state } = useLocation();
    const [orgDetails, setOrgDetails] = useState<OrganizationDetails>()
    const [paymentID, setPaymentID] = useState<string>("");
    const [paymentLink, setPaymentLink] = useState<string>("");
    const [chargebeeInvoice, setChargebeeInvoice] = useState<IEstimateInvoiceModel>()

    const checkout = (orgDetails) => {
        try {
            cbInstance.openCheckout({
                hostedPage: async () => {
                    var data = state.IsAddonRecharge ? getAddonData(orgDetails) : getData(orgDetails);

                    let modifyPlan = props.Stepdata.planHistory.filter((x) => x.StatusType === 1).find((x) => x.PlanId === props.Stepdata.Plan.Id)

                    var promise = state.IsAddonRecharge ? ChargebeeService.addonRecharge(data, state.AddonOccurrence || props.Stepdata.AddonOccurrence === TierOccurrence.RECURRING) : (!modifyPlan) ? ChargebeeService?.createHostPage(data) : chargebeeService.modifyHostPage(data)

                    return promise.then((response) => {
                        setPaymentID(response.data.hostpage.id)
                        return response.data.hostpage;
                    })
                },
                success: (hostedPageId: any) => {
                    cbInstance.closeAll();
                    (global as any).PaymentCompleted = true;
                    setTimeout(
                        () => {
                            props.HandleNext({
                                ...state,
                                paymentID: hostedPageId,
                                state: PaymentStatus.AWAITING,
                            })
                        }, 100
                    );
                },
                error: (error: any) => {
                    cbInstance.closeAll();
                },
                close: (e: any) => {
                    props.HandleNext({
                        paymentID: paymentID,
                        state: PaymentStatus.AWAITING,
                    })
                },
                step: (step: any) => {
                }
            });
        } catch (exception) {
            console.log("Catch Exception", exception);
        }
    }

    const getData = (orgDetails) => {
        let modifyPlan = props.Stepdata.planHistory.filter((x) => x.StatusType === RechargeStatus.ONGOING).find((x) => x.PlanId === props.Stepdata.Plan.Id)
        let data = (!modifyPlan)
            ? {
                "billing_address[first_name]": "",
                "billing_address[last_name]": "",
                "billing_address[company]": orgDetails?.Name,
                "billing_address[line1]": orgDetails?.HouseNumber,
                "billing_address[line2]": orgDetails?.Address,
                "billing_address[state_code]": orgDetails?.State,
                "billing_address[city]": orgDetails?.City,
                "billing_address[zip]": orgDetails?.ZipCode,
                "billing_address[country]": orgDetails?.Country,
                "billing_address[email]": orgDetails?.Email,
                "subscription[cf_is_sign_up]": false,
                "subscription_items[item_price_id][0]": `Pricing_${props.Stepdata.Tenure}_${props.Stepdata.Plan.Id}`,
                "subscription_items[quantity][0]": props.Stepdata.Count,
                "customer[id]": state.OrganizationId,
                "customer[email]": orgDetails?.Email,
                "customer[first_name]": orgDetails?.Name,
                "customer[last_name]": "",
                "customer[company]": orgDetails?.Name,
                "customer[phone]": "",
                "redirect_url": `${window.location.origin}/new-payment-status?OrganizationID=${state.OrganizationId}&planID=${props.Stepdata.Plan.Id}&Tenure=${props.Stepdata.Tenure}`,
                "cancel_url": `${window.location.origin}/new-payment-status?OrganizationID=${state.OrganizationId}&planID=${props.Stepdata.Plan.Id}&Tenure=${props.Stepdata.Tenure}`,
                "change_option": "immediately"
            }
            : {
                "subscription[id]": modifyPlan.SubscriptionId,
                "subscription_items[item_price_id][0]": `Pricing_${props.Stepdata.Tenure}_${modifyPlan.PlanId}`,
                "subscription_items[quantity][0]": props.Stepdata.Count,
                "customer[id]": state.OrganizationId,
                "customer[email]": orgDetails?.Email,
                "customer[first_name]": orgDetails?.Name,
                "customer[last_name]": "",
                "customer[company]": orgDetails?.Name,
                "customer[phone]": "",
                "change_option": modifyPlan?.Quantity < props.Stepdata.Count ? "immediately" : "end_of_term",
                "redirect_url": `${window.location.origin}/new-payment-status?OrganizationID=${state.OrganizationId}&planID=${props.Stepdata.Plan.Id}&Tenure=${props.Stepdata.Tenure}`,
                "cancel_url": `${window.location.origin}/new-payment-status?OrganizationID=${state.OrganizationId}&planID=${props.Stepdata.Plan.Id}&Tenure=${props.Stepdata.Tenure}`
            }
        if (UserService.hasOrgAdminRole()) {
            delete data["cancel_url"];
            delete data["redirect_url"];
        }

        return data;
    }

    const getAddonData = (orgDetails) => {
        let user = JSON.parse(localStorage.getItem("current-user")?.toString()!);
        let plan = (props.Stepdata?.Plan);

        if (plan?.PlaType === PlanType.TIER) {
            return null;
        }
        else {
            return UserService.hasSysAdminRole()
                ? {
                    "billing_address[first_name]": "",
                    "billing_address[last_name]": "",
                    "billing_address[company]": orgDetails?.Name,
                    "billing_address[line1]": orgDetails?.HouseNumber,
                    "billing_address[line2]": orgDetails?.Address,
                    "billing_address[state_code]": orgDetails?.State,
                    "billing_address[city]": orgDetails?.City,
                    "billing_address[zip]": orgDetails?.ZipCode,
                    "billing_address[country]": orgDetails?.Country,
                    "billing_address[email]": orgDetails?.Email,
                    "item_prices[item_price_id][0]": `Pricing_${props.Stepdata.Plan.Id}`,
                    "item_prices[quantity][0]": props.Stepdata.Count,
                    "customer[id]": state.OrganizationId,
                    "customer[email]": orgDetails?.Email,
                    "customer[first_name]": orgDetails?.Name,
                    "customer[last_name]": "",
                    "customer[company]": orgDetails?.Name,
                    "customer[phone]": "",
                    "redirect_url": `${window.location.origin}/new-payment-status?OrganizationID=${state.OrganizationId}&planID=${props.Stepdata.Plan.Id}&Tenure=${props.Stepdata.Tenure}`,
                    "cancel_url": `${window.location.origin}/new-payment-status?OrganizationID=${state.OrganizationId}&planID=${props.Stepdata.Plan.Id}&Tenure=${props.Stepdata.Tenure}`
                }
                : {
                    "billing_address[first_name]": user.firstName,
                    "billing_address[last_name]": user.lastName,
                    "billing_address[company]": orgDetails?.Name,
                    "billing_address[line1]": orgDetails?.HouseNumber,
                    "billing_address[line2]": orgDetails?.Address,
                    "billing_address[state_code]": orgDetails?.State,
                    "billing_address[city]": orgDetails?.City,
                    "billing_address[zip]": orgDetails?.ZipCode,
                    "billing_address[country]": orgDetails?.Country,
                    "billing_address[email]": orgDetails?.Email,
                    "item_prices[item_price_id][0]": `Pricing_${props.Stepdata.Plan.Id}`,
                    "item_prices[quantity][0]": props.Stepdata.Count,
                    "customer[id]": state.OrganizationId,
                    "customer[email]": orgDetails?.Email,
                    "customer[first_name]": user.firstName || "",
                    "customer[last_name]": user.lastName || "",
                    "customer[company]": orgDetails?.Name,
                    "customer[phone]": "",
                }
        }
    }

    const getHostPage = (orgDetails) => {
        try {
            let plan = props.Stepdata?.Plan;
            var data = state?.IsAddonRecharge ? getAddonData(orgDetails) : getData(orgDetails);
            let modifyPlan = props.Stepdata.planHistory.filter((x) => x.StatusType === RechargeStatus.ONGOING).find((x) => x.PlanId === props.Stepdata.Plan.Id)

            var promise = state.IsAddonRecharge ? ChargebeeService.addonRecharge(data, false) : (!modifyPlan) ? ChargebeeService?.createHostPage(data) : chargebeeService.modifyHostPage(data)

            return promise.then((response) => {
                setPaymentID(response.data.hostpage.id)
                setPaymentLink(response.data.hostpage.url)
                setChargebeeInvoice(mapChargebeeEstimateInvoice(response.data.estimate, plan.TierOccurrence === TierOccurrence.ONE_TIME))
            });
        } catch (exception) {
            console.log("Catch Exception", exception);
        }
    }

    useEffect(() => {
        OrganizationService.getOrganizationById(UserService.hasSysAdminRole() ? state.OrganizationId : UserService.getCurrentUserOrgId())
            .then(res => {
                let data = mapToOrganizationDetails(res.data)
                setOrgDetails(data)
                if (UserService.hasSysAdminRole()) {
                    getHostPage(data)
                }
                else {
                    checkout(data)
                }
            })
    }, [])

    return <>
        {
            UserService.hasSysAdminRole() ?
                <PaymentHostpageDetails LoadingDetails={!paymentID} PaymentLink={paymentLink} IsMobileDevice={props.IsMobileDevice} stepdata={props.Stepdata} ChargebeeInvoice={chargebeeInvoice} OrgDetails={orgDetails} /> :
                <Grid container className={`add-phone-number-paper-border paper-background h-v-50 m-auto br-2`}></Grid>
        }
    </>
};

export default NewPayment;